import { render, staticRenderFns } from "./demo-component.vue?vue&type=template&id=f05cf8d6&"
import script from "./demo-component.vue?vue&type=script&lang=ts&"
export * from "./demo-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports